import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Error403View from 'src/views/pages/Error403View';
import helpers from 'src/helpers';

function UserPermissionGuard({
  permissions,
  requiredPermissions,
  pathToRedirect,
  children,
}) {
  const {
    permissions: userRolePermissions,
  } = useSelector((state) => state?.account?.user?.userRole || {});

  if (permissions && !helpers.permissions.doesUserHaveOneOfPermissions(permissions, userRolePermissions)) {
    return pathToRedirect ? <Redirect to={pathToRedirect} /> : <Error403View />;
  }

  // CON-1487 Phase G — `requiredPermissions` is AND (all must be held),
  // used for admin routes that gate on ADMIN_TOOLS_VIEW plus a
  // feature-specific permission. `permissions` stays OR for compatibility.
  if (Array.isArray(requiredPermissions) && requiredPermissions.length) {
    const hasAll = requiredPermissions.every((p) => (
      helpers.permissions.doesUserHavePermission(p, userRolePermissions)
    ));
    if (!hasAll) {
      return pathToRedirect ? <Redirect to={pathToRedirect} /> : <Error403View />;
    }
  }

  return children;
}

UserPermissionGuard.propTypes = {
  permissions: PropTypes.array,
  requiredPermissions: PropTypes.array,
  pathToRedirect: PropTypes.string,
  children: PropTypes.any,
};

export default UserPermissionGuard;
